/**
 * Gestion du store de gestion des émoticônes
 */

import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import axios from '@js/tools/axios';

export const useEmoticonStore = defineStore('emoticon', (() => {

    // State de la liste des catégories
    const categories = ref(null);

    /**
     * Retourne les catégories
     * @return array|null
     */
    const getCategories = computed(() => {
        return categories.value;
    });

    /**
     * Chargement des émoticônes
     * @return Promise
     */
    const loadCategories = (() => {

        if(categories.value !== null) {
            return Promise.resolve();
        }

        const path = '/api/emoticons';

        return axios.get(path).then((response) => {
            const withCategoriesParam = (response && response.data && response.data.success && response.data.categories);
            const categoriesParam = (withCategoriesParam) ? response.data.categories : {};

            const newCategories = [];

            Object.keys(categoriesParam).forEach((categoryName) => {

                const categoryEmoticons = categoriesParam[categoryName] ?? {};
                const categoryEmoticonsFormatted = Object.keys(categoryEmoticons).map((emoticonKey) => {
                    return {
                        name: emoticonKey,
                        value: categoryEmoticons[emoticonKey]
                    };
                });

                const category = {
                    name: categoryName,
                    emoticons: categoryEmoticonsFormatted
                };

                if(category.emoticons.length > 0) {
                    newCategories.push(category);
                }
            });

            categories.value = newCategories;

            return Promise.resolve();
        });
    });

    return {
        getCategories,
        loadCategories
    };
}));
